var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"pl-0",attrs:{"cols":"3"}},[_c('div',{staticClass:"align-end mt-3 text-center"},[_c('a',_vm._g({staticClass:"text-right font-size-14 text-decoration-underline",on:{"click":_vm.logOut}},_vm.on),[_vm._v("\n            "+_vm._s(_vm.$t('view.dictionary.button_caption.logout'))+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20c69c4b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/link/LogoutLink.vue
// module id = mrj7
// module chunks = 1